// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gjsBTjGZ80fAL8Q0GVSq {
  font-family: var(--font-stack-full-book);
}

._yaZJjBhaFZ1LmEc2EAJ {
  padding: 0 32px;
}

.wk6VZZQJn4x77RYkg1xM {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 32px 0;
}

.DnW6sBf7Bm0vdU7QCiT_ {
  font-family: var(--font-stack-full-book);
  color: var(--grey-color-70);
  font-weight: 350;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
}

.f3ZzE7Ny08HI9GcA_cAw {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.ukwuZnju7Dv4RaYQn75g {
  height: 135px;
  margin: 32px 0;
}

.FJz_lF3KpAKiwIN487WJ {
  margin-bottom: 32px;
}

.CnXx7VyoN855c15c94ts {
  font-family: var(--font-stack-full-heavy);
  color: var(--grey-color-90);
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
}

.jgfLAVwxMF0v9WClxt5M {
  width: 62%;
}

.hmCbca1Y5g5bFqo00RLD {
  font-family: var(--font-stack-full-regular);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.18px;
}

.RQaNZyvAa_m077SRTDj9 {
  padding-top: 32px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 24px;
  row-gap: 24px;
  justify-content: flex-start;
}

.kscvcdLfUzpn_TI9AoZw {
  flex: 0 1 calc((100% - 48px) / 3);
  max-width: calc((100% - 48px) / 3);
  display: flex;
}

.kscvcdLfUzpn_TI9AoZw > * {
  flex: 1 1 auto;
}

@media (max-width: 1440px) {
  .kscvcdLfUzpn_TI9AoZw {
    flex: 0 1 calc((100% - 24px) / 2);
    max-width: calc((100% - 24px) / 2);
  }
}
@media (max-width: 960px) {
  .kscvcdLfUzpn_TI9AoZw {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.Ry7FQQ7hI4IdtpzRO2Fk {
  width: 100%;
  min-width: 0;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
}

.xYXxqenM1rlw5kvQ7XeN {
  color: var(--blue-color-60);
  font-family: var(--font-stack-full-medium);
  font-size: 20px;
  line-height: 28px;
  font-weight: 400;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}

.ZrHL2_HJi9IN9CRee20P {
  width: 36px;
  height: 36px;
  background-color: var(--grey-color-10);
  padding: 8px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.qIjW1p6oO5Om3sJBFB_U {
  color: var(--grey-color-60);
  font-family: var(--font-stack-full-medium);
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
}

.EaHG0qon9GBzzGxu_XIT {
  margin-left: 4px;
  padding-top: 4px;
}

.LyVkrXmw7jQaYadZEyVE {
  color: var(--grey-color-90);
  padding-top: 4px;
  margin-left: 4px;
}

.AXH9VUlm8nQPeTqxEDoA {
  font-family: Avenir Book, sans-serif;
  color: var(--grey-color-60);
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin: 32px 0;
  text-align: center;
}

.afAw8wmOoD8tpYdmiGn7 {
  font-family: Avenir Book, sans-serif;
  font-weight: 800;
  color: var(--grey-color-90);
  font-style: Heavy;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  margin-bottom: 16px;
}

.pFWYWJM8xIhgMwDLbf7J {
  font-family: Avenir Book, sans-serif;
  font-weight: 350;
  font-style: Book;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
}

.ofvPj8gweLE4fRDmGsvl {
  margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CohortInsightsLandingPage/CohortInsightsLandingPage.module.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,wCAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,yCAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AACF;;AAEA;EACE,iBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;AACF;;AAEA;EACE,iCAAA;EACA,kCAAA;EACA,aAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE;IACE,iCAAA;IACA,kCAAA;EACF;AACF;AAEA;EACE;IACE,cAAA;IACA,eAAA;EAAF;AACF;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,2BAAA;EACA,0CAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AADF;;AAIA;EACE,2BAAA;EACA,0CAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,2BAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,oCAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AADF;;AAIA;EACE,oCAAA;EACA,gBAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;AADF;;AAIA;EACE,oCAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,8BAAA;AADF;;AAGA;EACE,gBAAA;AAAF","sourcesContent":[".container {\n  font-family: var(--font-stack-full-book);\n}\n\n.mainSecondContainer {\n  padding: 0 32px;\n}\n\n.secondContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 32px 0;\n}\n\n.descriptionText {\n  font-family: var(--font-stack-full-book);\n  color: var(--grey-color-70);\n  font-weight: 350;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0;\n}\n\n.secondPartContainer {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.imageWrapper {\n  height: 135px;\n  margin: 32px 0;\n}\n\n.createReportTitleContainer {\n  margin-bottom: 32px;\n}\n\n.createFirstBoxText {\n  font-family: var(--font-stack-full-heavy);\n  color: var(--grey-color-90);\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.overviewTextContainer {\n  width: 62%;\n}\n\n.createReportButtonContainer {\n  font-family: var(--font-stack-full-regular);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  letter-spacing: -0.18px;\n}\n\n.reportsGrid {\n  padding-top: 32px;\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 24px;\n  row-gap: 24px;\n  justify-content: flex-start;\n}\n\n.reportTile {\n  flex: 0 1 calc((100% - 48px) / 3);\n  max-width: calc((100% - 48px) / 3);\n  display: flex;\n}\n\n.reportTile > * {\n  flex: 1 1 auto;\n}\n\n@media (max-width: 1440px) {\n  .reportTile {\n    flex: 0 1 calc((100% - 24px) / 2);\n    max-width: calc((100% - 24px) / 2);\n  }\n}\n\n@media (max-width: 960px) {\n  .reportTile {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n\n.reportCard {\n  width: 100%;\n  min-width: 0;\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n}\n\n.reportNameButton {\n  color: var(--blue-color-60);\n  font-family: var(--font-stack-full-medium);\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 400;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.deleteIconContainer {\n  width: 36px;\n  height: 36px;\n  background-color: var(--grey-color-10);\n  padding: 8px;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.reportLine {\n  color: var(--grey-color-60);\n  font-family: var(--font-stack-full-medium);\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  display: flex;\n  align-items: center;\n}\n\n.reportLineLabel {\n  margin-left: 4px;\n  padding-top: 4px;\n}\n\n.reportLineValue {\n  color: var(--grey-color-90);\n  padding-top: 4px;\n  margin-left: 4px;\n}\n\n.cohortDisabledMessage {\n  font-family: Avenir Book, sans-serif;\n  color: var(--grey-color-60);\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 32px 0;\n  text-align: center;\n}\n\n.cohortDisabledMessageTitle {\n  font-family: Avenir Book, sans-serif;\n  font-weight: 800;\n  color: var(--grey-color-90);\n  font-style: Heavy;\n  font-size: 20px;\n  line-height: 28px;\n  letter-spacing: 0%;\n  text-align: center;\n  vertical-align: middle;\n  margin-bottom: 16px;\n}\n\n.cohortDisabledMessageText {\n  font-family: Avenir Book, sans-serif;\n  font-weight: 350;\n  font-style: Book;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  text-decoration-skip-ink: auto;\n}\n.cohortDisabledMessageButtonContainer {\n  margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `gjsBTjGZ80fAL8Q0GVSq`,
	"mainSecondContainer": `_yaZJjBhaFZ1LmEc2EAJ`,
	"secondContainer": `wk6VZZQJn4x77RYkg1xM`,
	"descriptionText": `DnW6sBf7Bm0vdU7QCiT_`,
	"secondPartContainer": `f3ZzE7Ny08HI9GcA_cAw`,
	"imageWrapper": `ukwuZnju7Dv4RaYQn75g`,
	"createReportTitleContainer": `FJz_lF3KpAKiwIN487WJ`,
	"createFirstBoxText": `CnXx7VyoN855c15c94ts`,
	"overviewTextContainer": `jgfLAVwxMF0v9WClxt5M`,
	"createReportButtonContainer": `hmCbca1Y5g5bFqo00RLD`,
	"reportsGrid": `RQaNZyvAa_m077SRTDj9`,
	"reportTile": `kscvcdLfUzpn_TI9AoZw`,
	"reportCard": `Ry7FQQ7hI4IdtpzRO2Fk`,
	"reportNameButton": `xYXxqenM1rlw5kvQ7XeN`,
	"deleteIconContainer": `ZrHL2_HJi9IN9CRee20P`,
	"reportLine": `qIjW1p6oO5Om3sJBFB_U`,
	"reportLineLabel": `EaHG0qon9GBzzGxu_XIT`,
	"reportLineValue": `LyVkrXmw7jQaYadZEyVE`,
	"cohortDisabledMessage": `AXH9VUlm8nQPeTqxEDoA`,
	"cohortDisabledMessageTitle": `afAw8wmOoD8tpYdmiGn7`,
	"cohortDisabledMessageText": `pFWYWJM8xIhgMwDLbf7J`,
	"cohortDisabledMessageButtonContainer": `ofvPj8gweLE4fRDmGsvl`
};
export default ___CSS_LOADER_EXPORT___;
